import { NavLink } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

/**
 * AdminShell — lightweight admin chrome for OWNER_ADMIN pages
 * (Users, Orders inbox, Order detail). Mirrors AdminLanding markup so styling
 * stays consistent without adding new global CSS.
 */
export default function AdminShell({ title, children }) {
  const { user, logout } = useAuth();

  return (
    <div className="apwo-shell apwo-shell--admin" data-testid="admin-shell">
      <header className="apwo-shell-header">
        <p className="apwo-brand-eyebrow">AUTOPARTSB2B</p>
        <h1 className="apwo-shell-title" data-testid="admin-title">
          {title || "Admin — AP Warehouse Order"}
        </h1>
        <div className="apwo-shell-actions">
          <nav className="apwo-admin-nav" aria-label="Admin navigation" data-testid="admin-nav">
            <NavLink to="/admin" end className={({ isActive }) => "apwo-linky" + (isActive ? " apwo-linky--active" : "")} data-testid="admin-nav-users">Users</NavLink>
            <NavLink to="/admin/orders" className={({ isActive }) => "apwo-linky" + (isActive ? " apwo-linky--active" : "")} data-testid="admin-nav-orders">Orders Inbox</NavLink>
            <NavLink to="/admin/settings/smtp" className={({ isActive }) => "apwo-linky" + (isActive ? " apwo-linky--active" : "")} data-testid="admin-nav-smtp">SMTP</NavLink>
          </nav>
          <span className="apwo-user-chip" data-testid="admin-user">
            {user?.display_name} <span className="apwo-role-tag">{user?.role}</span>
          </span>
          <button className="apwo-btn-secondary" onClick={logout} data-testid="admin-logout">Sign out</button>
        </div>
      </header>
      <main className="apwo-shell-main">{children}</main>
      <footer className="apwo-shell-footer">
        AUTOPARTSB2B &middot; S1 Asia Pacific Traders Pty Ltd &middot; ABN 69 650 366 091
      </footer>
    </div>
  );
}
